import { i18n } from '@/vue';
import { ProjectStatus, ProjectType } from 'types';
import {
  alphaNumericDashUnderscoreRegex,
  alphaNumericDashUnderscoreWhitespaceRegex,
} from 'utils';
import { z } from 'zod';

export enum ProjectFormMode {
  CREATE = 'create',
  EDIT = 'edit',
}

export const projectFormValidator = (projectType: ProjectType) => {
  const schema = z.object({
    title: z
      .string()
      .regex(
        alphaNumericDashUnderscoreWhitespaceRegex,
        i18n.global.t('projectForm.projectTitleWrongSignes'),
      )
      .min(1)
      .max(100),
    number: z
      .string()
      .regex(
        alphaNumericDashUnderscoreRegex,
        i18n.global.t('projectForm.projectNumberWrongSignes'),
      )
      .min(1)
      .max(100),
    location: z.string().min(1).max(100),
    status: z.nativeEnum(ProjectStatus),
    description: z
      .string()
      .max(2000)
      .transform((val) => (val === '' ? undefined : val))
      .optional(),
    duration: z.preprocess(
      (val) => {
        if (!Array.isArray(val) || !val.length) return undefined;
        else return val;
      },
      z
        .union([z.array(z.date()).length(2), z.undefined()])

        .refine(
          (val) => val === undefined || val?.every((d) => d instanceof Date),
          {
            message: i18n.global.t('projectForm.errors.bothDatesRequired'),
          },
        ),
    ),
  });
  if (projectType === ProjectType.SUPPLIER_PROJECT) {
    return schema.extend({
      externalId: z.string().max(100).optional(),
      inspectionDueTime: z.number().int().min(1).max(1000),
    });
  } else return schema;
};

// TODO: Conditional type based on projectType?
export type ProjectFormFields = {
  title: string;
  number: string;
  externalId?: string;
  location: string;
  description?: string;
  duration?: Date[] | undefined;
  status: ProjectStatus;
  inspectionDueTime: number;
};
